import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgRebate = function SvgRebate(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_247_25607)",
        fillOpacity: 0.16,
        d: "M48.747 73.218q-.8.794-1.863.794t-1.857-.794L14.839 43.029a2.8 2.8 0 0 1-.644-.942A2.9 2.9 0 0 1 14 41.032V16.56q0-1.076.743-1.818Q15.485 14 16.56 14h24.47q.487 0 1.005.174t.968.537L73.09 44.797q.877.876.909 2.007.031 1.129-.781 1.943z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_247_25607)",
        d: "M44.747 69.218q-.8.794-1.863.794t-1.857-.794L10.839 39.029a2.8 2.8 0 0 1-.644-.942A2.9 2.9 0 0 1 10 37.032V12.56q0-1.076.743-1.818Q11.485 10 12.56 10h24.47q.487 0 1.005.174t.968.537L69.09 40.797q.877.876.909 2.007.031 1.129-.781 1.943zM42.97 67.47l24.5-24.535-30.41-30.374H12.561v24.47zM21.101 24.073q1.244 0 2.117-.899a2.97 2.97 0 0 0 .874-2.141q0-1.244-.866-2.117a2.86 2.86 0 0 0-2.11-.874q-1.308 0-2.181.866a2.86 2.86 0 0 0-.874 2.11q0 1.243.866 2.149.867.906 2.174.906"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_247_25607",
        x1: 14.627,
        x2: 73.165,
        y1: 44.005,
        y2: 44.005,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_247_25607",
        x1: 10.627,
        x2: 69.165,
        y1: 40.005,
        y2: 40.005,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgRebate as ReactComponent };
//# sourceMappingURL=Rebate.svg.es.js.map
